/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Invoice_Pdf_PendingInputs */

const cs_billing_invoice_pdf_pending = /** @type {(inputs: Billing_Invoice_Pdf_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF zatím není k dispozici`)
};

const en_billing_invoice_pdf_pending = /** @type {(inputs: Billing_Invoice_Pdf_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF not available yet`)
};

/**
* | output |
* | --- |
* | "PDF not available yet" |
*
* @param {Billing_Invoice_Pdf_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_invoice_pdf_pending = /** @type {((inputs?: Billing_Invoice_Pdf_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Invoice_Pdf_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_invoice_pdf_pending(inputs)
	return cs_billing_invoice_pdf_pending(inputs)
});